<template>
  <div>
    <table width="100%">
      <thead>
        <tr>
          <th>
            <my-header h1="Prospect Student Report"></my-header>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <table border="1" width="100%" style="border-collapse: collapse; font-size: 12px">
              <tr>
                <th class="bg" align="left" width="20">Semester:</th>
                <td align="left" width="20">{{sess}}</td>
                <th class="bg" align="left" width="15">Degree:</th>
                <td align="left" width="15">{{deg}}</td>
                <th class="bg" align="left" width="20">Program:</th>
                <td align="left" width="20">{{pro}}</td>
              </tr>
              <tr>
                <th class="bg" align="left" width="20">Village/Town/City:</th>
                <td align="left" width="20">{{cit}}</td>
                <th class="bg" align="left" width="15">Category:</th>
                <td align="left" width="15">{{cat}}</td>
                <th class="bg" align="left" width="15">District:</th>
                <td align="left" width="15">{{dis}}</td>
              </tr>
              <tr>
                <th class="bg" align="left" width="20">Payment Verified:</th>
                <td align="left" width="20">{{pay}}</td>
                <th class="bg" align="left" width="15">Document Verified:</th>
                <td align="left" width="15">{{doc}}</td>
                <th class="bg" align="left" width="15">Hostel Required:</th>
                <td align="left" width="15">{{hos}}</td>
              </tr>
            </table>
            <table border="1" width="100%" style="border-collapse: collapse; font-size: 12px; margin-top: 10px">
              <thead>
                <tr>
                  <th>Sr. No.</th>
                  <th>Challan No.</th>
                  <th>Name</th>
                  <th>Father Name</th>
                  <th>Contact No</th>
                  <th>Father Contact No</th>
                  <th>Department</th>
                  <th>Dated</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, ind) in data">
                  <td>{{ind+1}}</td>
                  <td>OL{{item.FormNo}}</td>
                  <td>{{item.Name}}</td>
                  <td>{{item.FathersName}}</td>
                  <td>{{item.MobileNo}}</td>
                  <td>{{item.FatherMobileNo}}</td>
                  <td>{{item.DepName}}</td>
                  <td>{{item.Date}}</td>
                  <td align="right">{{item.Amount.toLocaleString()}}</td>
                </tr>
                <tr>
                  <th class="bg" colspan="8">Grand Total</th>
                  <td align="right">{{grandTotal.toLocaleString()}}</td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>


<script>
  const axios = require('axios').default;
  export default ({
    data() {
      return {
        data: [],
        sess: '',
        pro: '',
        dep: '',
        deg: '',
        pay: '',
        doc: '',
        dis: '',
        cat: '',
        hos:'',
        cit: '',
        grandTotal: 0,
      }
    },
    mounted: function () {
      this.pagePrint();
    },
    methods: {
      pagePrint() {
        var vm = this;
        axios.post('/api/AdmissionApi/getProspectStudentData')
          .then(function (res) {
            vm.data = res.data.lst;
            vm.sess = res.data.sess;
            vm.pro = res.data.pro;
            vm.dep = res.data.dep;
            vm.deg = res.data.deg;
            vm.pay = res.data.pay;
            vm.doc = res.data.doc;
            vm.dis = res.data.dis;
            vm.cit = res.data.cit;
            vm.cat = res.data.cat;
            vm.hos = res.data.hos;
            vm.grandTotal = res.data.grandTotal;
          })
      }
    }
  })
</script>

<style>
  .bg {
    background-color: lightgrey;
  }
</style>



// WEBPACK FOOTER //
// src/components/onlineadmission/onlineadmissionprint.vue